import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostBinding,
} from '@angular/core';

@Component({
  selector: 'mpro-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
})
export class ToggleSwitchComponent {
  @Input() label: string | undefined;
  @Input() state: boolean = false;
  @HostBinding('class.disabled') @Input() disabled: boolean = false;
  @HostBinding('class.dark') @Input() dark: boolean = false;
  @Output() public stateChange = new EventEmitter<boolean>();

  onChange(e) {
    e.preventDefault();
    this.stateChange.emit(this.state);
  }
}
